import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAutoCrop: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="auto-crop, ai-crop"><path d="M5.4 2H4.6L3.6 4.6L1 5.6V6.4L3.6 7.4L4.6 10H5.4L6.4 7.4L9 6.4V5.6L6.4 4.6L5.4 2Z" fill="currentColor"/><path d="M19.4 14H18.6L17.6 16.6L15 17.6V18.4L17.6 19.4L18.6 22H19.4L20.4 19.4L23 18.4V17.6L20.4 16.6L19.4 14Z" fill="currentColor"/><path d="M11.75 4.78516H20.25V11.2852" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 12.75V19.25H12.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconAutoCrop;
